export default __webpack_public_path__ + "static/beach-40bf8a760e4c53720fc29dd134de68c2.jpg";